import styled, { css } from 'styled-components';
import { HEX } from '../../Styles/LegacyColors/index.js';
import { commonResets } from '../../Styles/Utils/commonResets.js';

// TO DO: Align and extract these to theme. (WP-254)
// TO DO: Extract styles from _commonStyles to packages/styles (WP-255)
const FormBoxWrapper = styled.div.withConfig({
    displayName: "FormBox.styles__FormBoxWrapper",
    componentId: "sc-2d518e35-0"
})`
    ${commonResets}
    & *,
    &:before,
    &:after,
    & *:before,
    & *:after {
        ${commonResets}
    }

    position: relative;
    margin-bottom: 15px;
`;
const FormBoxBox = styled.label.withConfig({
    displayName: "FormBox.styles__FormBoxBox",
    componentId: "sc-2d518e35-1"
})`
    display: block;
    height: 60px;
    width: 100%;
    position: relative;
    border-bottom: 2px solid ${HEX.grey};
    transition: border 0.2s ease;

    ${(props)=>props.autoHeight && css`
            height: auto;
        `}

    ${(props)=>props.active && css`
            border-color: ${HEX.blue};
        `}

    ${(props)=>props.error && css`
            border-color: ${HEX.purple};
        `}

    ${(props)=>props.noBorder && css`
            border: none;
        `}
`;
const FormBoxInputBox = styled.div.withConfig({
    displayName: "FormBox.styles__FormBoxInputBox",
    componentId: "sc-2d518e35-2"
})`
    width: 100%;
    height: 100%;

    input {
        width: 100%;
        height: 100%;
        padding: 15px 0 0;
        color: ${HEX.darkGrey};
        font-size: 16px;
        line-height: 1.35;
        font-weight: 300;
        background: transparent;
        position: relative;
        border: none;
        outline: none;
        transition: color 0.2s ease;
    }

    select {
        width: 100%;
        height: 100%;
        padding: 15px 0 0;
        color: ${HEX.darkGrey};
        font-size: 16px;
        line-height: 1.35;
        font-weight: 300;
        background: transparent;
        position: relative;
        border: none;
        outline: none;
        transition: color 0.2s ease;
        appearance: none;
    }

    textarea {
        width: 100%;
        height: 100%;

        padding: 30px 0 15px;
        box-sizing: border-box;
        color: ${HEX.darkGrey};
        font-size: 16px;
        line-height: 1.35;
        font-weight: 300;
        background: transparent;
        position: relative;
        border: none;
        outline: none;
        transition: color 0.2s ease;
        display: block;
        resize: none;
    }

    input[type='checkbox'] {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        opacity: 0;
        cursor: pointer;
    }

    ${(props)=>props.autoHeight && css`
            height: auto;
        `}

    ${(props)=>props.active && css`
            input,
            select,
            textarea {
                color: ${HEX.blue};
            }
        `}
`;
const FormBoxLabel = styled.div.withConfig({
    displayName: "FormBox.styles__FormBoxLabel",
    componentId: "sc-2d518e35-3"
})`
    position: absolute;
    font-size: 16px;
    line-height: 1;
    font-weight: 300;
    height: 60px;
    display: flex;
    color: ${HEX.darkGrey};
    align-items: center;
    transition: all 0.2s cubic-bezier(0.13, 0.6, 0.43, 0.92);

    ${(props)=>props.active && css`
            height: 24px;
            font-size: 14px;
            color: ${HEX.blue};
        `}
`;
const FormBoxError = styled.div.withConfig({
    displayName: "FormBox.styles__FormBoxError",
    componentId: "sc-2d518e35-4"
})`
    font-weight: 300;
    margin-top: 5px;
    font-size: 14px;
    line-height: 1.35;
    color: ${HEX.purple};
`;

export { FormBoxBox, FormBoxError, FormBoxInputBox, FormBoxLabel, FormBoxWrapper };
